"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SMALLTEXT = exports.MONOSPACE = exports.HEADER6 = exports.HEADER5 = exports.HEADER4 = exports.HEADER3 = exports.HEADER2 = exports.HEADER1 = exports.FONT_STYLES = exports.FONT_FAMILY = exports.EXTRASMALLTEXT = exports.EXTRAEXTRASMALLTEXT = exports.BASETEXT = exports.BASE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _breakpoints = _interopRequireDefault(require("./breakpoints"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import type { FontRule, Typography } from './ThemeTypes';*/
var FONT_FAMILY = exports.FONT_FAMILY = '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';
var FONT_STYLES = exports.FONT_STYLES = {
  base: {
    fontFamily: FONT_FAMILY,
    fontSize: '1rem',
    // 16px
    // Depends on the user agent. Desktop browsers (including Firefox) use a default value of roughly `1.2`, depending on the element's `font-family`.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
    lineHeight: 'normal',
    fontWeight: 400,
    letterSpacing: 'normal',
    textRendering: 'optimizeLegibility'
  },
  header1: {
    fontSize: '1.8125rem',
    // 29px
    fontWeight: 700,
    letterSpacing: '-0.018rem'
  },
  header2: {
    fontSize: '1.3145rem',
    // 21px
    fontWeight: 700,
    letterSpacing: '-0.018rem'
  },
  header3: {
    fontSize: '1.19rem',
    // 19px
    fontWeight: 700,
    letterSpacing: '-0.018rem'
  },
  header4: {
    fontSize: '1.068rem',
    // 17px
    fontWeight: 600,
    letterSpacing: '-0.012rem'
  },
  header5: {
    fontSize: '.938rem',
    // 15px
    fontWeight: 500,
    letterSpacing: '-0.006rem'
  },
  header6: {
    fontSize: '.8125rem',
    // 13px
    fontWeight: 500,
    letterSpacing: '-0.006rem'
  },
  baseText: {
    fontSize: '1.063rem',
    // 17px
    lineHeight: '1.43rem',
    letterSpacing: '-0.012rem',
    fontWeight: 400
  },
  smallText: {
    fontSize: '.9375rem',
    // 15px
    lineHeight: '1.31rem',
    letterSpacing: '-0.012rem',
    fontWeight: 400
  },
  extraSmallText: {
    fontSize: '.818rem',
    // 13px
    lineHeight: '1.18rem',
    letterSpacing: '-0.006rem',
    fontWeight: 400
  },
  extraExtraSmallText: {
    fontSize: '.6875rem',
    // 11px
    lineHeight: '1.18rem',
    letterSpacing: '-0.01375rem',
    fontWeight: 400
  },
  monospace: {
    fontFamily: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace',
    fontSize: '1.063rem',
    // 17px
    lineHeight: '1.43rem',
    letterSpacing: '-0.012rem',
    fontWeight: 400
  }
};
var BASE /*: FontRule*/ = exports.BASE = FONT_STYLES.base;
var HEADER1 /*: FontRule*/ = exports.HEADER1 = _objectSpread(_objectSpread(_objectSpread({}, BASE), FONT_STYLES.header1), {}, {
  display: 'block',
  margin: 0
});
var HEADER2 /*: FontRule*/ = exports.HEADER2 = _objectSpread(_objectSpread(_objectSpread({}, BASE), FONT_STYLES.header2), {}, {
  display: 'block',
  margin: 0
});
var HEADER3 /*: FontRule*/ = exports.HEADER3 = _objectSpread(_objectSpread(_objectSpread({}, BASE), FONT_STYLES.header3), {}, {
  display: 'block',
  margin: 0
});
var HEADER4 /*: FontRule*/ = exports.HEADER4 = _objectSpread(_objectSpread(_objectSpread({}, BASE), FONT_STYLES.header4), {}, {
  display: 'block',
  margin: 0
});
var HEADER5 /*: FontRule*/ = exports.HEADER5 = _objectSpread(_objectSpread(_objectSpread({}, BASE), FONT_STYLES.header5), {}, {
  display: 'block',
  margin: 0
});
var HEADER6 /*: FontRule*/ = exports.HEADER6 = _objectSpread(_objectSpread(_objectSpread({}, BASE), FONT_STYLES.header6), {}, {
  display: 'block',
  margin: 0
});
var BASETEXT /*: FontRule*/ = exports.BASETEXT = _objectSpread(_objectSpread({}, BASE), FONT_STYLES.baseText);
var SMALLTEXT /*: FontRule*/ = exports.SMALLTEXT = _objectSpread(_objectSpread({}, BASE), FONT_STYLES.smallText);
var EXTRASMALLTEXT /*: FontRule*/ = exports.EXTRASMALLTEXT = _objectSpread(_objectSpread({}, BASE), FONT_STYLES.extraSmallText);
var EXTRAEXTRASMALLTEXT /*: FontRule*/ = exports.EXTRAEXTRASMALLTEXT = _objectSpread(_objectSpread({}, BASE), FONT_STYLES.extraExtraSmallText);
var MONOSPACE /*: FontRule*/ = exports.MONOSPACE = _objectSpread(_objectSpread(_objectSpread({}, BASE), FONT_STYLES.monospace), {}, (0, _defineProperty2.default)({
  display: 'block',
  whiteSpace: 'normal'
}, _breakpoints.default.gt.tablet.landscape, {
  whiteSpace: 'pre-wrap'
}));
var TYPOGRAPHY /*: Typography*/ = ({
  base: BASE,
  header1: HEADER1,
  header2: HEADER2,
  header3: HEADER3,
  header4: HEADER4,
  header5: HEADER5,
  header6: HEADER6,
  baseText: BASETEXT,
  smallText: SMALLTEXT,
  extraSmallText: EXTRASMALLTEXT,
  extraExtraSmallText: EXTRAEXTRASMALLTEXT,
  monospace: MONOSPACE
} /*: Typography*/);
var _default = exports.default = TYPOGRAPHY;
//# sourceMappingURL=typography.js.map